import { onBeforeMount } from "vue"
import useNavigationStore from "@/stores/navigationStore.js"
import useFilterStore from "@/stores/filterStore.js"

export default function useDefaultDateRange(dateRange) {
  const navigationStore = useNavigationStore()
  const filterStore = useFilterStore()

  onBeforeMount(() => {
    if (navigationStore.skipDefaultDateRange) {
      navigationStore.skipDefaultDateRange = false
      return
    }
    filterStore.setDateRange(dateRange)
  })
}
